import React from 'react';
import { useTranslation } from 'react-i18next';

import ErrorBoundaryContainer, { ErrorBoundaryContainerProps } from '../../../common/components/error-boundary/containers/ErrorBoundaryContainer';

import css from './ErrorBoundary.scss';

const ErrorBoundary: React.FC<ErrorBoundaryContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    return (
        <ErrorBoundaryContainer {...containerProps}>
            {(props) => {
                if (props.hasError) {
                    return (
                        <React.Fragment>
                            { /*
                                <header id={css.headerMain}>
                                    <div className={css.mainNav}>
                                        <div className={css.skewLogos}>
                                            <div className={css.skewRegulator}>
                                                <Link className={css.cardBody} to={`${props.config.BaseURL}`}>
                                                    <img src={imgLogoBMW} alt="Logotipo BMW" className={css.logomarca} />
                                                    <img src={imgLogoMini} alt="Logotipo MINI" className={css.logomarca} />
                                                </Link>
                                            </div>
                                        </div>
                                        <div className={css.eventName}>
                                            <h2>{t('common:title')}</h2>
                                        </div>
                                    </div>
                                </header>
                            */ }
                            {props.error.showGeneric &&
                            <div className={css.errorContent}>
                                <h1>{t(`errorMessages.errorBoundary.somethingWentWrongHeader`)}</h1>
                                <p>{t(`errorMessages.errorBoundary.somethingWentWrongDescription`)}</p>
                                <p dangerouslySetInnerHTML={{ __html: t(`errorMessages.errorBoundary.reload`).replace('{0}', props.config.BaseURL) }} />
                                <p />

                                { /*
                                <h2>{t('common:errorMessages:errorBoundary:technicalDetails')}</h2>
                                <p>{t('common:errorMessages:errorBoundary:theError')}: {props.error.message}</p>
                                <p>{t('common:errorMessages:errorBoundary:whereItHappened')}: {props.error.stack}</p>
                                */ }
                            </div>}
                            {!props.error.showGeneric &&
                            <div className={css.errorContent}>
                                <h1>{props.error.message}</h1>
                                {props.error.info &&
                                    <p dangerouslySetInnerHTML={{ __html: props.error.info }} />
                                }
                                <p />
                            </div>}
                        </React.Fragment>
                    );
                }
                return (<React.Fragment>{containerProps.children}</React.Fragment>);
            }}
        </ErrorBoundaryContainer>
    );
};

export default ErrorBoundary;
